const videos = document.querySelectorAll("video");

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const video = entry.target;
    const button = video.nextElementSibling;

    if (entry.isIntersecting) {
      video.play();
      button.dataset.status = "playing";
    } else {
      video.pause();
      button.dataset.status = "paused";
    }
  });
}, {
  threshold: 0.5 
});

videos.forEach(video => observer.observe(video));